import { memo } from 'react';

import { cn } from '@/lib/utils';

const DoneIcon = memo(
  ({ width = 20, height = 20, className }: { width?: number; height?: number; className?: string }) => {
    return (
      <div className={cn('text-indigo-500', className)}>
        <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM16.8838 5.61621C16.3956 5.12806 15.6044 5.12806 15.1162 5.61621L7.75 12.9824L4.88379 10.1162L4.78906 10.0303C4.29809 9.62979 3.57387 9.65855 3.11621 10.1162C2.65855 10.5739 2.62979 11.2981 3.03027 11.7891L3.11621 11.8838L6.86621 15.6338L6.96094 15.7197C7.45191 16.1202 8.17613 16.0914 8.63379 15.6338L16.8838 7.38379C17.3719 6.89563 17.3719 6.10437 16.8838 5.61621Z"
            fill="currentColor"
          />
        </svg>
      </div>
    );
  }
);

DoneIcon.displayName = 'DoneIcon';

export { DoneIcon };
